import { v4 as uuidv4 } from "uuid";
import config from "../config";
const root = config.REACT_APP_API_URL;

const _uploadImage = (file) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    const fileName = uuidv4();
    formData.append("image", file);
    //formData.append('image-name', 'img-upload');

    fetch(root + `api/file/upload`, {
      method: "POST",
      headers: {
        "file-name": fileName,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        const filePath = `/api/file/${fileName}`;
        //onUpload(filePath);
        //setImg(filePath);
        resolve(filePath);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

export const updateBrand = (updateBody) => {
  const jwt = localStorage.getItem("jwtToken");
  if (!jwt) return;
  const jwtPayload = JSON.parse(atob(jwt.split("Bearer ")[1].split(".")[1]));
  const brand = jwtPayload.organization;

  return new Promise(async (resolve, reject) => {
    if (updateBody.logo) {
      try {
        const logo = await _uploadImage(updateBody.logo);
        if (logo) {
          updateBody.logo = logo;
        }
      } catch (err) {
        reject("Could not upload image");
      }
    }

    if (updateBody.queue) {
      let profileQueue = await Promise.all(
          updateBody.queue.map(async (img) => {
          if(typeof img === 'object'){
            return await _uploadImage(img)
          }
          return img
        })
      );
      profileQueue = [...updateBody.queue.filter(p => typeof p === 'string'), ...profileQueue]

      //updateBody.queue = updateBody.queue.filter(q=>q instanceof String)
      updateBody.queue = [...profileQueue];
    } else if(Array.isArray(updateBody.queue) && updateBody.queue.length === 0) {
      updateBody.queue = []
    }
    if(Array.isArray(updateBody.socials) && updateBody.socials.length === 0){
      updateBody.socials = []
    }
    if(Array.isArray(updateBody.genres) && updateBody.genres.length === 0){
      updateBody.genres = []
    }

    fetch(root + `api/brands/${brand}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt,
      },
      body: JSON.stringify(updateBody),
    })
      .then((response) => response.json())
      .then((response) => {
        //onUpload(filePath);
        //setImg(filePath);
        resolve(response);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};

export const getBrand = (brand) => {
  return new Promise((resolve, reject) => {
    fetch(root + `api/brands/${brand}`)
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        console.log({ err });
        reject(err);
      });
  });
};

export const getBrandReports = () => {
  const jwt = localStorage.getItem("jwtToken");
  if (!jwt) return;
  const jwtPayload = JSON.parse(atob(jwt.split("Bearer ")[1].split(".")[1]));
  const brand = jwtPayload.organization;

  return new Promise((resolve, reject) => {
    fetch(root + `api/report`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jwt,
      },
      body: JSON.stringify({ brand }),
    })
      .then((response) => response.json())
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        console.log(err);
      });


  });
};
